module.exports = __webpack_public_path__ + "static/media/zip.5bcb2dd0.svg";